import { SvgIcon, SvgIconProps } from "@mui/material";

export const AlignStartVerticalIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
        <g clip-path="url(#a)">
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M10.833 11.667H6.667c-.92 0-1.667.746-1.667 1.666V15c0 .92.746 1.667 1.667 1.667h4.166c.92 0 1.667-.747 1.667-1.667v-1.667c0-.92-.746-1.666-1.667-1.666ZM16.667 3.333h-10C5.747 3.333 5 4.08 5 5v1.667c0 .92.746 1.666 1.667 1.666h10c.92 0 1.666-.746 1.666-1.666V5c0-.92-.746-1.667-1.666-1.667ZM1.667 1.667v16.666"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h20v20H0z" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
